import api from '@libs/api'

import { handleServiceError } from '@utils/errors'
import {
  IEnterpriseSettings,
  IFeatureAvailability,
  ISolutionsV2Settings,
} from '@utils/types'

const routeName = '/global-settings'

const getDaysRequiredForDeletion = async (): Promise<number> => {
  try {
    const response = await api.get({
      path: `${routeName}/days-required-for-deletion`,
    })

    return response
  } catch (err: any) {
    throw handleServiceError(err)
  }
}

const getEnterpriseSettings = async (): Promise<IEnterpriseSettings> => {
  try {
    const response = await api.get({
      path: `${routeName}/enterprise-settings`,
    })

    return response
  } catch (err: any) {
    throw handleServiceError(err)
  }
}

const getMyUserFeatureAvailabilities =
  async (): Promise<IFeatureAvailability> => {
    try {
      const response = await api.get({
        path: `${routeName}/features/me`,
      })

      return response
    } catch (err: any) {
      throw handleServiceError(err)
    }
  }

const getIsSolutionsEnabled = async (): Promise<boolean> => {
  try {
    const response = await api.get({
      path: `${routeName}/solutions-v2/enabled`,
      authenticate: false,
    })

    return response
  } catch (err: any) {
    throw handleServiceError(err)
  }
}

const getSolutionsV2Settings = async (): Promise<ISolutionsV2Settings> => {
  try {
    const response = await api.get({
      path: `${routeName}/solutions-v2`,
    })

    return response
  } catch (err: any) {
    throw handleServiceError(err)
  }
}

const getAllSettings = async (): Promise<Record<string, unknown>> => {
  try {
    const response = await api.get({
      path: `${routeName}/admin`,
    })

    return response
  } catch (err: any) {
    throw handleServiceError(err)
  }
}

const updateSettings = async (
  updates: Array<{ key: string; value: unknown }>
): Promise<void> => {
  try {
    await api.put({
      path: `${routeName}/admin`,
      data: { updates },
    })
  } catch (err: any) {
    throw handleServiceError(err)
  }
}

export default {
  getDaysRequiredForDeletion,
  getEnterpriseSettings,
  getMyUserFeatureAvailabilities,
  getSolutionsV2Settings,
  getIsSolutionsEnabled,
  getAllSettings,
  updateSettings,
}
